import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import ProductOccupancyForm from './input/ProductOccupancyForm';
import ProductOccupancyGraphContainer from './graph/ProductOccupancyGraphContainer';
import ProductReservationsContainer from './reservations/ProductReservationsContainer';
import Section from 'components/ui/general/Section';
import ShowButton from 'components/button/ShowButton';
import Title from 'components/ui/general/Title';
import translate from 'components/hoc/translate';

const ProductOccupancy = (props) => {
    const {
        form,
        id,
        product,
        translate,
    } = props;

    const {
        title,
    } = product;

    const breadcrumbs = [
        {
            label: translate('resources.products.title'),
            link: '/products',
        },
        {
            label: title,
            link: `/products/${ id }/show`,
        },
        {
            label: translate('resources.products.actions.occupancy'),
        },
    ];

    return (
        <div>
            <Breadcrumbs breadcrumbs={ breadcrumbs } />

            <Header>
                <Title title={ title } />

                <Actions>
                    <ProductOccupancyForm
                        form={ form }
                    />
                    <ShowButton
                        label={ translate('actions.show') }
                        url={ `/products/${ id }/show` }
                    />
                </Actions>
            </Header>

            <Section>
                <Column>
                    <InnerColumn>
                        <ProductOccupancyGraphContainer
                            product={ product }
                            form={ form }
                            id={ id }
                        />
                    </InnerColumn>
                </Column>
            </Section>

            <Section>
                <ProductReservationsContainer
                    form={ form }
                    id={ id }
                    source='destination_arrival_date'
                />
                <ProductReservationsContainer
                    form={ form }
                    id={ id }
                    source='destination_departure_date'
                />
            </Section>

            <Section>
                <ProductReservationsContainer
                    form={ form }
                    id={ id }
                />
            </Section>
        </div>
    );
};

ProductOccupancy.propTypes = {
    form: PropTypes.string.isRequired,
    id: PropTypes.string,
    product: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    translate,
);

export default enhance(ProductOccupancy);


// WEBPACK FOOTER //
// ./src/pages/products/productOccupancy/ProductOccupancy.js